import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

const AddSurgeryDialog = ({ open, onClose, onAdd }) => {
  const [formData, setFormData] = useState({
    name: '',
    reason: '',
    date: new Date().toISOString().split('T')[0],
    surgeon: '',
    facility: '',
    complications: '',
    care_instructions: '',
    recovery_notes: '',
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await onAdd({
        ...formData,
        surgeon: formData.surgeon || undefined,
        facility: formData.facility || undefined,
        complications: formData.complications || undefined,
        care_instructions: formData.care_instructions || undefined,
        recovery_notes: formData.recovery_notes || undefined,
      });

      setFormData({
        name: '',
        reason: '',
        date: new Date().toISOString().split('T')[0],
        surgeon: '',
        facility: '',
        complications: '',
        care_instructions: '',
        recovery_notes: '',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[600px] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Add Surgery</DialogTitle>
          <DialogDescription>Record surgical procedure information</DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit}>
          <div className="grid gap-4 py-4">
            <div className="grid gap-2">
              <Label htmlFor="name">Surgery/Procedure Name *</Label>
              <Input id="name" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} required />
            </div>

            <div className="grid gap-2">
              <Label htmlFor="reason">Reason for Surgery *</Label>
              <Input id="reason" value={formData.reason} onChange={(e) => setFormData({ ...formData, reason: e.target.value })} required />
            </div>

            <div className="grid gap-2">
              <Label htmlFor="date">Date *</Label>
              <Input id="date" type="date" value={formData.date} onChange={(e) => setFormData({ ...formData, date: e.target.value })} required />
            </div>

            <div className="grid grid-cols-2 gap-3">
              <div className="grid gap-2">
                <Label htmlFor="surgeon">Surgeon/Provider</Label>
                <Input id="surgeon" value={formData.surgeon} onChange={(e) => setFormData({ ...formData, surgeon: e.target.value })} />
              </div>
              <div className="grid gap-2">
                <Label htmlFor="facility">Facility</Label>
                <Input id="facility" value={formData.facility} onChange={(e) => setFormData({ ...formData, facility: e.target.value })} />
              </div>
            </div>

            <div className="grid gap-2">
              <Label htmlFor="complications">Complications (if any)</Label>
              <Textarea id="complications" value={formData.complications} onChange={(e) => setFormData({ ...formData, complications: e.target.value })} rows={2} />
            </div>

            <div className="grid gap-2">
              <Label htmlFor="care_instructions">Post-Surgery Care Instructions</Label>
              <Textarea id="care_instructions" value={formData.care_instructions} onChange={(e) => setFormData({ ...formData, care_instructions: e.target.value })} rows={3} />
            </div>

            <div className="grid gap-2">
              <Label htmlFor="recovery_notes">Recovery Notes</Label>
              <Textarea id="recovery_notes" value={formData.recovery_notes} onChange={(e) => setFormData({ ...formData, recovery_notes: e.target.value })} rows={2} />
            </div>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose}>Cancel</Button>
            <Button type="submit" disabled={loading} className="bg-[#B8E6D5] hover:bg-[#A0D6C5] text-gray-900">
              {loading ? 'Adding...' : 'Add Surgery'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default AddSurgeryDialog;